import Button from './button';
import { Element } from 'react-scroll';

const HeroSection = () => {
    const scrollToElement = (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            const navbarHeight = 72;
            const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <Element name="home" id="home" className="hero-section">
            <div className="hero-inner">
                <div className="hero-left">
                    <h1 className="text-brand-800">
                        Unlock Your Potential: <br />Dear Beautiful Soul, Start Your Journey to Healing and Expansion.
                    </h1>
                    <p className="text-textBody">
                         Identify traumas that are keeping you stuck, and map out the first steps toward the life you deserve and desire.
                    </p>
                    <Button onClick={() => scrollToElement('booking-form')} type="primary" className="mt-2">
                        Schedule a 1:1 Discovery Session Now
                    </Button>
                </div>
                <div className="hero-right">
                    <img className="hero-image" src={`${process.env.PUBLIC_URL}/assets/Sireesha_.jpg`} alt="Vidya Sireesha - IPHM Certified Trauma Informed Therapist" />
                </div>
            </div>
        </Element>
    );
};

export default HeroSection;
